import { render } from "./SpecialProvisions.vue?vue&type=template&id=1584cfeb&scoped=true"
import script from "./SpecialProvisions.vue?vue&type=script&lang=js"
export * from "./SpecialProvisions.vue?vue&type=script&lang=js"

import "./SpecialProvisions.vue?vue&type=style&index=0&id=1584cfeb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1584cfeb"]])

export default __exports__